export const ADDRESS_UPDATE_SUCCESS = 'ADDRESS_UPDATE_SUCCESS';

var initialState = {
    byId: {},
    allIds: []
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.address) {
        state = {
            ...state,
            byId: {
                ...state.byId,
                ...action.payload.entities.address
            }
        }
    }
    switch (action.type) {
        default:
            return state;
    }
};